// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import { NameContainer, NameContainerLink } from "components/user/Name";

// #####################################################

export const StyledNameWrapper = styled.div.withConfig({
	shouldForwardProp: (prop) => !["addSpecialPadding"].includes(prop),
})`
	padding-left: 0.5rem;
	background-color: rgba(0, 0, 0, 0.25);
	margin-top: 0.5rem;
	padding: 0.3rem 1rem;
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.element};

	z-index: 1;
	color: ${({ theme: { colors } }) => colors.whiteTrueAlways};

	text-align: center;
	display: flex;
	justify-content: center;

	${NameContainer} {
		padding-right: ${({ addSpecialPadding }) =>
			addSpecialPadding ? "0" : "0.5rem"};
		padding-left: ${({ addSpecialPadding }) =>
			addSpecialPadding ? "0" : "0.5rem"};
		color: ${({ theme: { colors } }) => colors.whiteTrueAlways};

		span {
			color: ${({ theme: { colors } }) => colors.whiteTrueAlways};
		}
	}

	${NameContainerLink} {
		color: ${({ theme: { colors } }) => colors.whiteTrueAlways};
	}

	&:hover {
		background-color: rgba(0, 0, 0, 0.15);
	}
`;

// #####################################################
